<!--
Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
SPDX-License-Identifier: Apache-2.0
-->

<!-- This SFC is responsible for drawing the header banner for the page. -->

<template>
  <div class="d-flex justify-content-center">
    <p class="h4">Virtual Waiting Room on AWS System Admin</p>
  </div>
</template>

<script setup>
// Banner is a purely presentational component with no logic
</script>
